import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Spinner,
} from "reactstrap";
import { login } from "store/actions/authActions";
import { useHistory } from "react-router-dom";

const Login = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [eye, setEye] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleLogin = (e) => {
    e.preventDefault();
    const creds = {
      email: email,
      password: password,
    };
    setIsLoading(true);
    dispatch(login(creds))
      .then((user) =>
        history.push(
          `${user.type === "admin" ? "/super-admin/index" : "/admin"}`
        )
      )
      .finally(() => setIsLoading(false));
  };

  return (
    <Col lg="5" md="7" className="login">
      <Card className="bg-secondary shadow border-0">
        <CardBody className="px-lg-5 py-lg-4">
          <div className=" d-flex flex-column justify-content-center align-items-center">
            <img
              src="https://firebasestorage.googleapis.com/v0/b/nexteats-staging.appspot.com/o/MPink.c81056cd41fc845875a3.png?alt=media&token=c459e672-0dfd-4118-8225-477b262180ab"
              alt="logo"
              onClick={() => history.push("/")}
              className="mb-3 w-25"
              style={{ cursor: "pointer" }}
            />
            <div className="d-flex flex-column justify-content-center align-items-center">
              <h3 className="title">Welcome</h3>
              <p className="typography">
                Enter your credentials to access your account
              </p>
            </div>
          </div>
          <Form onSubmit={handleLogin}>
            <FormGroup className="mb-3">
              <Label className="form_label">Email</Label>
              <Input
                placeholder="example@gmail.com"
                type="email"
                autoComplete="new-email"
                defaultValue={email}
                required
                onChange={(e) => setEmail(e.target.value)}
              />
            </FormGroup>
            <FormGroup className="mb-0">
              <Label className="form_label">Password</Label>
              <div className="login__password">
                <Input
                  placeholder="Password"
                  type={eye ? "text" : "password"}
                  autoComplete="new-password"
                  defaultValue={password}
                  required
                  onChange={(e) => setPassword(e.target.value)}
                />
                {eye ? (
                  <FaEyeSlash
                    className="eye_icon"
                    onClick={() => setEye(!eye)}
                  />
                ) : (
                  <FaEye className="eye_icon" onClick={() => setEye(!eye)} />
                )}
              </div>
            </FormGroup>
            <Row className="mt-0 mx-2 justify-content-end">
              <Link to="/auth/forget-password" className="pointer">
                <small>Forgot password?</small>
              </Link>
            </Row>
            <Button
              className="mt-3 mb-1 w-100 login__btn"
              type="submit"
              disabled={!email || !password || isLoading}
            >
              {isLoading ? <Spinner size="sm" /> : "Login"}
            </Button>
            <Row className="mt-0 mb-2 mx-2 justify-content-end">
              <Link to="/auth/sign-up" className="pointer">
                <small>
                  Don't have an account?{" "}
                  <span className="text-danger"> Sign up</span>
                </small>
              </Link>
            </Row>
          </Form>
        </CardBody>
      </Card>
    </Col>
  );
};

export default Login;
